import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconPlaceholder } from '../Icon/IconPlaceholder';
import { Box } from '../layout/Box';
import { FlexContainer } from '../layout/FlexContainer';
import { ExpansionTableRowArrow } from './ExpansionTableRowArrow';
export const ExpansionTableRow = ({ open, tableHasDetail, showIconPlaceholder, hasAllRowsExpanded, columns, }) => {
    const mappedColumns = columns.map(({ key, grow, testId, content }) => {
        return (_jsx(Box, { basis: 0, grow: grow, testId: testId, children: content }, key));
    });
    // Table can have expandable details either for every row, some or none at all
    // To assure consistent layout, we have to show a placeholder if particular row doesn't have detail
    const getExpansionTableArrow = () => {
        if (!tableHasDetail || hasAllRowsExpanded)
            return null;
        if (showIconPlaceholder)
            return _jsx(IconPlaceholder, {});
        return _jsx(ExpansionTableRowArrow, { open: !!open });
    };
    const maybeExpansionTableArrow = getExpansionTableArrow();
    return (_jsxs(FlexContainer, { verticalAlign: 'center', gap: true, children: [maybeExpansionTableArrow, mappedColumns] }));
};
